export default "__VITE_ASSET__CREtAWgd__"